export const COUPONS: {[key: string]: number} = {
  'discount_4_usd_off_onetime': 4,
  'discount_10_usd_off_onetime': 10,
};
